(() => {
  angular
    .module('complianceFrameworkApp.vms')
    .controller('UserAuditsController', UserAuditsController);

  /* ngInject */
  function UserAuditsController($stateParams, userAuditService, sessionService) {
    const vm = this;

    /* eslint-disable no-undef */
    vm.currentPage = $stateParams.currentPage || 1;
    vm.endDate = moment().format('YYYY-MM-DD');
    vm.generateReport = generateReport;
    vm.loaded = false;
    vm.pageChange = pageChange;
    vm.reportFormat = 'html';
    vm.reportType = 'document_access';
    vm.reset = reset;
    vm.startDate = moment().subtract(1, 'month').format('YYYY-MM-DD');
    vm.totalCount = null;
    vm.userAudits = [];
    /* eslint-enable no-undef */

    function generateReport() {
      let params = {
        end_date: vm.endDate,
        report_format: vm.reportFormat,
        start_date: vm.startDate,
        page: vm.currentPage
      };

      if (vm.reportType == 'document_access') {
        userAuditService(sessionService.getAuthToken()).document_access(params, response => {
          vm.userAudits = response.data;
          vm.loaded = true;
          vm.totalCount = parseInt(response.headers['x-total']);
        });
      } else {
        userAuditService(sessionService.getAuthToken()).system_access(params, response => {
          vm.userAudits = response.data;
          vm.loaded = true;
          parseInt(response.headers['x-total']);
        });
      }
    }

    function reset() {
      vm.currentPage = 1;
      vm.loaded = false;
      vm.userAudits = [];
    }

    function pageChange(newPageNumber, _oldPageNumber) {
      vm.userAudits = [];
      vm.currentPage = newPageNumber;
      vm.generateReport();
    }
  }
})();
